export enum VehicleAddressSizeEnum {
    Short = 'short',
    WithPostal = 'with-postal',
    Full = 'full'
  }
  